import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

import {
  CONTENT_APPROVALS_MOCK,
  CONTENT_ATTACHMENTS_MOCK,
  CONTENT_COMMENTS_MOCK,
  CONTENT_DECREES_MOCK,
  CONTENT_FINANCIAL_MOCK,
  CONTENT_IMPORTED_DECREE_MOCK_1,
  CONTENT_IMPORTED_DECREE_MOCK_2,
  CONTENT_INFO_MOCK,
  CONTENT_NOTES_MOCK,
  CONTENT_RIGHTS_MOCK,
  CONTENT_WEBCAST_MOCK,
  HEADER_MOCK,
  PRIMARY_ACTIONS_MOCK,
  SIDEBAR_MOCK
} from './decrees.mock';

import { DecreeTabType, IDecreeDetailTabContent } from '~/decrees/decree-detail/decree-detail.types';
import { Menu, MenuItem } from '~/ui/detail/detail-action-button/detail-action-buttons.types';
import { DetailHeader } from '~/ui/detail/detail-header/detail-header.types';

@Injectable()
export class DecreesService {
  constructor(private readonly http: HttpClient) {}

  public fetchDecreeHeader(id: string): Observable<DetailHeader> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}`);
    return of(HEADER_MOCK).pipe(delay(2000));
  }

  public fetchDecreePrimaryActions(id: string): Observable<MenuItem[]> {
    //return this.http.get<MenuItem[]>(`${environment.BACKEND_URL}/decrees/${id}/primaryactions`);
    return of(PRIMARY_ACTIONS_MOCK).pipe(delay(2500));
  }

  public fetchDecreeSidebar(id: string): Observable<Menu[]> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/sidebar`);
    return of(SIDEBAR_MOCK).pipe(delay(2500));
  }

  public fetchDecreeGeneral(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.DECREES>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/general`);
    return of(CONTENT_DECREES_MOCK).pipe(delay(2000));
  }

  public fetchDecreeAttachments(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.ATTACHMENTS>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/attachments`);
    return of(CONTENT_ATTACHMENTS_MOCK).pipe(delay(5000));
  }

  public fetchDecreeComments(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.COMMENTS>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/comments`);
    return of(CONTENT_COMMENTS_MOCK).pipe(delay(6000));
  }

  public fetchDecreeApprovals(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.APPROVALS>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/approvals`);
    return of(CONTENT_APPROVALS_MOCK).pipe(delay(3000));
  }

  public fetchDecreeInfo(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.INFO>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/info`);
    return of(CONTENT_INFO_MOCK).pipe(delay(2000));
  }

  public fetchDecreeRights(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.RIGHTS>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/rights`);
    return of(CONTENT_RIGHTS_MOCK).pipe(delay(2000));
  }

  public fetchDecreeFinancial(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.FINANCIAL>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/financial`);
    return of(CONTENT_FINANCIAL_MOCK).pipe(delay(3500));
  }

  public fetchDecreeNotes(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.NOTES>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/notes`);
    return of(CONTENT_NOTES_MOCK).pipe(delay(1000));
  }

  public fetchDecreeWebcast(id: string): Observable<IDecreeDetailTabContent<DecreeTabType.WEBCAST>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${id}/webcast`);
    return of(CONTENT_WEBCAST_MOCK).pipe(delay(1000));
  }

  public fetchDecreeImportedDecree(
    decreeId: string,
    importId: string
  ): Observable<IDecreeDetailTabContent<DecreeTabType.IMPORTED_DECREE>> {
    //return this.http.get<DetailHeader>(`${environment.BACKEND_URL}/decrees/${decreeId}/importeddecree`);
    return of(importId === '1' ? CONTENT_IMPORTED_DECREE_MOCK_1 : CONTENT_IMPORTED_DECREE_MOCK_2).pipe(delay(1000));
  }
}
